(function () {
  var PARTNER_ENDPOINT = 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/portalPublicLandingMapPartnersV1';
  var MAPLIBRE_VERSION = '5.24.0';
  var MAPLIBRE_JS = 'https://unpkg.com/maplibre-gl@' + MAPLIBRE_VERSION + '/dist/maplibre-gl.js';
  var MAPLIBRE_CSS = 'https://unpkg.com/maplibre-gl@' + MAPLIBRE_VERSION + '/dist/maplibre-gl.css';
  var MAP_TILES = 'https://tiles.openfreemap.org/planet';
  var MAP_GLYPHS = 'https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf';
  var PARTNER_SOURCE_ID = 'florame-partners';
  var PARTNER_DOM_MIN_ZOOM = 14.75;
  var PARTNER_NAME_MIN_ZOOM = 16.15;
  var FALLBACK_PARTNERS = [{
    partnerId: 'fiori-e-piante-di-nino',
    name: 'Fiori e Piante di Nino',
    partnerSlug: 'fiori-nino',
    storefrontUrl: 'https://florame.ai/pages/fiori-nino',
    logoUrl: 'https://storage.googleapis.com/flower-ai-2d7aa.firebasestorage.app/partner_logos/fiori-e-piante-di-nino.webp?v=1775044463930',
    description: 'Un fiorista locale verificato, con pagina e catalogo su Florame.',
    phone: '3394324010',
    addressLine: 'Via Chiana 4, 00198 Roma RM',
    googleMapsUrl: 'https://maps.app.goo.gl/WCWyjaFCz7PxN7dj7',
    city: 'Roma',
    province: 'RM',
    postalCode: '00198',
    countryCode: 'IT',
    regionName: 'Lazio',
    regionCode: 'ITI4',
    lat: 41.9220773,
    lng: 12.5042593,
    pickupEnabled: true,
    badges: ['Partner verificato', 'Consegna in giornata']
  }];
  var REGION_CENTERS = {
    abruzzo: { center: [13.3995, 42.3498], city: "L'Aquila", zoom: 14.2 },
    basilicata: { center: [15.8051, 40.6404], city: 'Potenza', zoom: 14.2 },
    calabria: { center: [16.5944, 38.9098], city: 'Catanzaro', zoom: 14.2 },
    campania: { center: [14.2681, 40.8518], city: 'Napoli', zoom: 14.4 },
    emilia_romagna: { center: [11.3426, 44.4949], city: 'Bologna', zoom: 14.4 },
    friuli_venezia_giulia: { center: [13.7768, 45.6495], city: 'Trieste', zoom: 14.4 },
    lazio: { center: [12.4964, 41.9028], city: 'Roma', zoom: 14.4 },
    liguria: { center: [8.9463, 44.4056], city: 'Genova', zoom: 14.4 },
    lombardia: { center: [9.19, 45.4642], city: 'Milano', zoom: 14.4 },
    marche: { center: [13.5189, 43.6158], city: 'Ancona', zoom: 14.2 },
    molise: { center: [14.6592, 41.5603], city: 'Campobasso', zoom: 14.2 },
    piemonte: { center: [7.6869, 45.0703], city: 'Torino', zoom: 14.4 },
    puglia: { center: [16.8719, 41.1171], city: 'Bari', zoom: 14.4 },
    sardegna: { center: [9.1217, 39.2238], city: 'Cagliari', zoom: 14.3 },
    sicilia: { center: [13.3614, 38.1157], city: 'Palermo', zoom: 14.3 },
    toscana: { center: [11.2558, 43.7696], city: 'Firenze', zoom: 14.4 },
    trentino_alto_adige: { center: [11.1211, 46.0679], city: 'Trento', zoom: 14.2 },
    umbria: { center: [12.3888, 43.1107], city: 'Perugia', zoom: 14.2 },
    valle_d_aosta: { center: [7.3201, 45.737], city: 'Aosta', zoom: 14.2 },
    veneto: { center: [12.3155, 45.4408], city: 'Venezia', zoom: 14.2 }
  };
  var state = {
    stage: null,
    gate: null,
    overlay: null,
    mapNode: null,
    map: null,
    mapReady: false,
    markers: [],
    markerMode: '',
    partnerLayersBound: false,
    partnerByKey: {},
    partners: FALLBACK_PARTNERS.slice(),
    activeRegion: null,
    activePartners: [],
    selectedPartner: null,
    libraryPromise: null,
    idleFrame: 0,
    idleDirection: 1,
    gestureHintTimer: 0,
    viewportObserver: null,
    offscreenTimer: 0,
    autoReturning: false,
    reducedMotion: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  };

  function normalize(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function finite(value, min, max) {
    var parsed = Number(value);
    return Number.isFinite(parsed) && parsed >= min && parsed <= max ? parsed : null;
  }

  function safeUrl(value, fallback) {
    try {
      var url = new URL(String(value || ''), window.location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return fallback || '#';
      return url.href;
    } catch (_) {
      return fallback || '#';
    }
  }

  function partnerCoordinates(partner) {
    var lat = finite(partner && partner.lat, -90, 90);
    var lng = finite(partner && partner.lng, -180, 180);
    return lat === null || lng === null ? null : [lng, lat];
  }

  function visiblePartner(partner) {
    return !!partner && !!partnerCoordinates(partner) && !!String(partner.name || '').trim();
  }

  function loadPartners() {
    return fetch(PARTNER_ENDPOINT, {
      headers: { Accept: 'application/json' },
      credentials: 'omit',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('partners_' + response.status);
      return response.json();
    }).then(function (payload) {
      var partners = Array.isArray(payload && payload.partners) ? payload.partners.filter(visiblePartner) : [];
      if (partners.length) state.partners = partners;
      decorateCoverageMap();
      refreshOpenMapPartners();
      return state.partners;
    }).catch(function () {
      state.partners = FALLBACK_PARTNERS.slice();
      decorateCoverageMap();
      refreshOpenMapPartners();
      return state.partners;
    });
  }

  function refreshOpenMapPartners() {
    if (!state.activeRegion || !state.overlay || state.overlay.hidden) return;
    state.activePartners = regionPartners(state.activeRegion);
    syncPartnerSource();
    syncMarkerPresentation(true);
  }

  function loadMapLibrary() {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (state.libraryPromise) return state.libraryPromise;
    state.libraryPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-flp-maplibre]')) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = MAPLIBRE_CSS;
        css.setAttribute('data-flp-maplibre', MAPLIBRE_VERSION);
        document.head.appendChild(css);
      }
      var existing = document.querySelector('script[data-flp-maplibre]');
      if (existing) {
        existing.addEventListener('load', function () { resolve(window.maplibregl); }, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }
      var script = document.createElement('script');
      script.src = MAPLIBRE_JS;
      script.async = true;
      script.setAttribute('data-flp-maplibre', MAPLIBRE_VERSION);
      script.onload = function () { resolve(window.maplibregl); };
      script.onerror = function () { reject(new Error('maplibre_unavailable')); };
      document.head.appendChild(script);
    });
    return state.libraryPromise;
  }

  function icon(name) {
    if (name === 'back') return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
    if (name === 'focus') return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/></svg>';
    if (name === 'pin') return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></svg>';
    if (name === 'shop') return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10v10h16V10M3 4h18l-2 6H5L3 4Z"/><path d="M9 20v-6h6v6"/></svg>';
    return '';
  }

  function createMapStyle() {
    var localName = ['coalesce', ['get', 'name:it'], ['get', 'name'], ['get', 'name_en']];
    var roadWidth = [
      'interpolate', ['linear'], ['zoom'],
      12, ['match', ['get', 'class'], ['motorway', 'trunk', 'primary'], 2.1, ['secondary', 'tertiary'], 1.45, ['minor', 'street', 'street_limited'], 0.9, 0.55],
      18, ['match', ['get', 'class'], ['motorway', 'trunk', 'primary'], 15, ['secondary', 'tertiary'], 10.5, ['minor', 'street', 'street_limited'], 7.2, ['service', 'track'], 3.4, 2.2]
    ];
    var roadShadowWidth = [
      'interpolate', ['linear'], ['zoom'],
      12, ['match', ['get', 'class'], ['motorway', 'trunk', 'primary'], 3.3, ['secondary', 'tertiary'], 2.65, ['minor', 'street', 'street_limited'], 2.1, 1.75],
      18, ['match', ['get', 'class'], ['motorway', 'trunk', 'primary'], 18.2, ['secondary', 'tertiary'], 13.7, ['minor', 'street', 'street_limited'], 10.4, ['service', 'track'], 6.6, 5.4]
    ];
    return {
      version: 8,
      glyphs: MAP_GLYPHS,
      sources: {
        openmaptiles: {
          type: 'vector',
          url: MAP_TILES,
          attribution: '© OpenStreetMap contributors · OpenFreeMap'
        }
      },
      light: {
        anchor: 'viewport',
        color: '#fff4f8',
        intensity: 0.42,
        position: [1.15, 205, 34]
      },
      layers: [
        {
          id: 'florame-background',
          type: 'background',
          paint: { 'background-color': '#f2ecef' }
        },
        {
          id: 'florame-landcover',
          type: 'fill',
          source: 'openmaptiles',
          'source-layer': 'landcover',
          paint: { 'fill-color': '#e9e5df', 'fill-opacity': 0.86 }
        },
        {
          id: 'florame-landuse',
          type: 'fill',
          source: 'openmaptiles',
          'source-layer': 'landuse',
          paint: {
            'fill-color': ['match', ['get', 'class'],
              ['residential', 'suburb', 'quarter', 'neighbourhood'], '#f0dce4',
              ['commercial', 'retail'], '#ead7df',
              ['industrial', 'railway'], '#ded9dc',
              ['school', 'university', 'college'], '#eadfe7',
              '#eee4e8'
            ],
            'fill-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0.5, 13, 0.72, 17, 0.52]
          }
        },
        {
          id: 'florame-park',
          type: 'fill',
          source: 'openmaptiles',
          'source-layer': 'park',
          paint: { 'fill-color': '#dce9dc', 'fill-opacity': 0.92 }
        },
        {
          id: 'florame-water',
          type: 'fill',
          source: 'openmaptiles',
          'source-layer': 'water',
          paint: { 'fill-color': '#cfe5ed', 'fill-opacity': 0.96 }
        },
        {
          id: 'florame-waterways',
          type: 'line',
          source: 'openmaptiles',
          'source-layer': 'waterway',
          minzoom: 11,
          paint: {
            'line-color': '#b8d9e5',
            'line-opacity': 0.82,
            'line-width': ['interpolate', ['linear'], ['zoom'], 11, 0.6, 18, 2.6]
          }
        },
        {
          id: 'florame-boundaries',
          type: 'line',
          source: 'openmaptiles',
          'source-layer': 'boundary',
          minzoom: 6,
          filter: ['all', ['>=', ['get', 'admin_level'], 3], ['<=', ['get', 'admin_level'], 8]],
          paint: {
            'line-color': '#cdbdc4',
            'line-dasharray': [2, 2],
            'line-opacity': ['interpolate', ['linear'], ['zoom'], 6, 0.36, 15, 0.68],
            'line-width': ['interpolate', ['linear'], ['zoom'], 6, 0.5, 16, 1.2]
          }
        },
        {
          id: 'florame-roads-shadow',
          type: 'line',
          source: 'openmaptiles',
          'source-layer': 'transportation',
          minzoom: 12,
          paint: {
            'line-color': '#cfc4c9',
            'line-opacity': 0.88,
            'line-width': roadShadowWidth
          }
        },
        {
          id: 'florame-roads',
          type: 'line',
          source: 'openmaptiles',
          'source-layer': 'transportation',
          minzoom: 12,
          paint: {
            'line-color': '#ffffff',
            'line-opacity': 0.94,
            'line-width': roadWidth
          }
        },
        {
          id: 'florame-rail',
          type: 'line',
          source: 'openmaptiles',
          'source-layer': 'transportation',
          minzoom: 11,
          filter: ['match', ['get', 'class'], ['rail', 'transit'], true, false],
          paint: {
            'line-color': '#a89ba1',
            'line-dasharray': [1.2, 1.5],
            'line-opacity': 0.72,
            'line-width': ['interpolate', ['linear'], ['zoom'], 11, 0.5, 18, 1.8]
          }
        },
        {
          id: 'florame-buildings-3d',
          type: 'fill-extrusion',
          source: 'openmaptiles',
          'source-layer': 'building',
          minzoom: 11.8,
          paint: {
            'fill-extrusion-color': [
              'interpolate', ['linear'], ['coalesce', ['get', 'render_height'], ['get', 'height'], 0],
              0, '#efdbe2', 24, '#dda8ba', 80, '#bd7891'
            ],
            'fill-extrusion-height': ['coalesce', ['get', 'render_height'], ['get', 'height'], 7],
            'fill-extrusion-base': ['coalesce', ['get', 'render_min_height'], ['get', 'min_height'], 0],
            'fill-extrusion-opacity': 0.94,
            'fill-extrusion-vertical-gradient': true
          }
        },
        {
          id: 'florame-district-labels',
          type: 'symbol',
          source: 'openmaptiles',
          'source-layer': 'place',
          minzoom: 9.2,
          maxzoom: 16.2,
          filter: ['match', ['get', 'class'], ['borough', 'suburb'], true, false],
          layout: {
            'text-field': localName,
            'text-font': ['Noto Sans Bold'],
            'text-size': ['interpolate', ['linear'], ['zoom'], 9.2, 10, 13.5, 12.5, 16.2, 14],
            'text-letter-spacing': 0.075,
            'text-transform': 'uppercase',
            'text-max-width': 9,
            'text-padding': ['interpolate', ['linear'], ['zoom'], 9.2, 18, 16.2, 11],
            'symbol-sort-key': ['coalesce', ['get', 'rank'], 30],
            'text-pitch-alignment': 'viewport',
            'text-rotation-alignment': 'viewport'
          },
          paint: {
            'text-color': '#6f4052',
            'text-opacity': ['interpolate', ['linear'], ['zoom'], 9.2, 0.78, 12, 0.96, 16.2, 0.76],
            'text-halo-color': 'rgba(255,251,253,.97)',
            'text-halo-width': 2,
            'text-halo-blur': 0.35
          }
        },
        {
          id: 'florame-neighbourhood-labels',
          type: 'symbol',
          source: 'openmaptiles',
          'source-layer': 'place',
          minzoom: 13.5,
          filter: ['match', ['get', 'class'], ['quarter', 'neighbourhood', 'hamlet'], true, false],
          layout: {
            'text-field': localName,
            'text-font': ['Noto Sans Regular'],
            'text-size': ['interpolate', ['linear'], ['zoom'], 10.8, 9.5, 14, 11, 18, 13],
            'text-letter-spacing': 0.055,
            'text-max-width': 8,
            'text-padding': ['interpolate', ['linear'], ['zoom'], 10.8, 12, 18, 7],
            'symbol-sort-key': ['coalesce', ['get', 'rank'], 40],
            'text-allow-overlap': true,
            'text-pitch-alignment': 'viewport',
            'text-rotation-alignment': 'viewport'
          },
          paint: {
            'text-color': '#765a66',
            'text-opacity': ['interpolate', ['linear'], ['zoom'], 10.8, 0.7, 13, 0.94, 18, 0.84],
            'text-halo-color': 'rgba(255,255,255,.96)',
            'text-halo-width': 1.65,
            'text-halo-blur': 0.25
          }
        },
        {
          id: 'florame-road-labels',
          type: 'symbol',
          source: 'openmaptiles',
          'source-layer': 'transportation_name',
          minzoom: 12.5,
          layout: {
            'symbol-placement': 'line',
            'symbol-spacing': 280,
            'text-field': localName,
            'text-font': ['Noto Sans Regular'],
            'text-size': ['interpolate', ['linear'], ['zoom'], 12.5, 9, 18, 13],
            'text-letter-spacing': 0.015,
            'text-max-angle': 34,
            'text-padding': 4,
            'text-pitch-alignment': 'viewport',
            'text-rotation-alignment': 'map'
          },
          paint: {
            'text-color': '#57474f',
            'text-halo-color': 'rgba(255,255,255,.96)',
            'text-halo-width': 1.5,
            'text-halo-blur': 0.3
          }
        },
        {
          id: 'florame-settlement-labels',
          type: 'symbol',
          source: 'openmaptiles',
          'source-layer': 'place',
          minzoom: 5,
          filter: ['match', ['get', 'class'], ['city', 'town', 'village'], true, false],
          layout: {
            'text-field': localName,
            'text-font': ['Noto Sans Bold'],
            'text-size': ['interpolate', ['linear'], ['zoom'], 5, 11, 16, 16],
            'text-letter-spacing': 0.015,
            'text-max-width': 9,
            'text-padding': 16
          },
          paint: {
            'text-color': '#2f2027',
            'text-halo-color': 'rgba(255,255,255,.94)',
            'text-halo-width': 1.8,
            'text-halo-blur': 0.35
          }
        },
        {
          id: 'florame-poi-labels',
          type: 'symbol',
          source: 'openmaptiles',
          'source-layer': 'poi',
          minzoom: 15.4,
          filter: ['<=', ['coalesce', ['get', 'rank'], 30], 20],
          layout: {
            'text-field': localName,
            'text-font': ['Noto Sans Regular'],
            'text-size': ['interpolate', ['linear'], ['zoom'], 15.4, 9, 18, 11],
            'text-max-width': 11,
            'text-line-height': 1.08,
            'text-offset': [0, 0.45],
            'text-padding': 8
          },
          paint: {
            'text-color': '#67545d',
            'text-halo-color': 'rgba(255,255,255,.92)',
            'text-halo-width': 1.35
          }
        },
        {
          id: 'florame-house-numbers',
          type: 'symbol',
          source: 'openmaptiles',
          'source-layer': 'housenumber',
          minzoom: 17.2,
          layout: {
            'text-field': ['get', 'housenumber'],
            'text-font': ['Noto Sans Regular'],
            'text-size': 9,
            'text-padding': 2
          },
          paint: {
            'text-color': '#8a7880',
            'text-halo-color': 'rgba(255,255,255,.88)',
            'text-halo-width': 1
          }
        }
      ]
    };
  }

  function buildOverlay() {
    if (state.overlay || !state.stage) return;
    var overlay = document.createElement('section');
    overlay.className = 'flp-city3d';
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-label', 'Vista urbana 3D dei partner Florame');
    overlay.innerHTML = '' +
      '<div class="flp-city3d__map" data-flp-city3d-map></div>' +
      '<div class="flp-city3d__light" aria-hidden="true"></div>' +
      '<header class="flp-city3d__topbar">' +
        '<button type="button" class="flp-city3d__icon-button" data-flp-city3d-back aria-label="Torna ai confini della regione">' + icon('back') + '</button>' +
        '<div class="flp-city3d__place"><span>Vista urbana 3D</span><strong data-flp-city3d-region>Regione</strong><em data-flp-city3d-city>Città</em></div>' +
        '<button type="button" class="flp-city3d__perspective" data-flp-city3d-perspective aria-label="Passa alla vista 2D" aria-pressed="true"><span data-mode="2d">2D</span><span data-mode="3d" class="is-active">3D</span></button>' +
      '</header>' +
      '<div class="flp-city3d__gesture-hint" data-flp-city3d-gesture-hint aria-hidden="true"><span>↕</span><strong>Due dita</strong><em>trascina su o giù per inclinare</em></div>' +
      '<div class="flp-city3d__loading" data-flp-city3d-loading><span></span><strong>Entro nella città</strong><em>Sto costruendo la vista 3D…</em></div>' +
      '<aside class="flp-city3d__partner" data-flp-city3d-partner hidden aria-live="polite"></aside>';
    state.stage.appendChild(overlay);
    state.overlay = overlay;
    state.mapNode = overlay.querySelector('[data-flp-city3d-map]');
    overlay.querySelector('[data-flp-city3d-back]').addEventListener('click', closeCityView);
    overlay.querySelector('[data-flp-city3d-perspective]').addEventListener('click', togglePerspective);
    overlay.addEventListener('pointermove', function (event) {
      var rect = overlay.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      overlay.style.setProperty('--flp-city-light-x', (((event.clientX - rect.left) / rect.width) * 100).toFixed(1) + '%');
      overlay.style.setProperty('--flp-city-light-y', (((event.clientY - rect.top) / rect.height) * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  function regionPartners(detail) {
    var regionName = normalize(detail.regionName);
    var regionCode = String(detail.regionId || '').toUpperCase();
    var countryCode = String(detail.countryCode || '').toUpperCase();
    return state.partners.filter(function (partner) {
      if (countryCode && String(partner.countryCode || 'IT').toUpperCase() !== countryCode) return false;
      var sameCode = regionCode && String(partner.regionCode || '').toUpperCase() === regionCode;
      var sameName = regionName && normalize(partner.regionName) === regionName;
      return sameCode || sameName;
    });
  }

  function activeCamera() {
    var partners = state.activePartners;
    var first = partners.length ? partnerCoordinates(partners[0]) : null;
    var regionKey = normalize(state.activeRegion && state.activeRegion.regionName);
    var fallback = REGION_CENTERS[regionKey] || { center: [12.4964, 41.9028], city: 'Città', zoom: 14.2 };
    return {
      center: first || fallback.center,
      city: (partners[0] && partners[0].city) || fallback.city,
      zoom: first ? 16.65 : fallback.zoom,
      pitch: first ? 66 : 58,
      bearing: first ? -27 : -18
    };
  }

  function setLoading(visible, failed) {
    if (!state.overlay) return;
    var loader = state.overlay.querySelector('[data-flp-city3d-loading]');
    loader.hidden = !visible;
    loader.classList.toggle('is-error', !!failed);
    if (failed) {
      loader.querySelector('strong').textContent = 'Vista 3D non disponibile';
      loader.querySelector('em').textContent = 'Torna ai confini e riprova tra poco.';
    }
  }

  function openCityView(detail) {
    if (!detail || !detail.regionName || !state.stage) return;
    buildOverlay();
    state.activeRegion = detail;
    state.activePartners = regionPartners(detail);
    state.selectedPartner = null;
    state.overlay.classList.remove('has-open-partner', 'is-flat');
    state.overlay.hidden = false;
    state.overlay.setAttribute('aria-hidden', 'false');
    state.stage.classList.add('is-city3d-open');
    state.gate.classList.add('is-city3d-active');
    state.overlay.querySelector('[data-flp-city3d-region]').textContent = detail.regionName;
    var camera = activeCamera();
    state.overlay.querySelector('[data-flp-city3d-city]').textContent = camera.city;
    state.overlay.querySelector('[data-flp-city3d-partner]').hidden = true;
    var originalBack = state.gate.querySelector('[data-flp-map-back-country]');
    if (originalBack) originalBack.hidden = true;
    startViewportGuard();
    setLoading(true, false);
    loadMapLibrary().then(function () {
      ensureMap(camera);
    }).catch(function () {
      setLoading(true, true);
    });
  }

  function closeCityView() {
    stopIdleOrbit();
    stopViewportGuard();
    if (!state.overlay || state.overlay.hidden || state.overlay.classList.contains('is-leaving')) return;
    state.overlay.classList.add('is-leaving');
    window.setTimeout(function () {
      state.overlay.hidden = true;
      state.overlay.setAttribute('aria-hidden', 'true');
      state.overlay.classList.remove('is-leaving', 'has-open-partner', 'is-flat');
      state.stage.classList.remove('is-city3d-open');
      state.gate.classList.remove('is-city3d-active');
      var originalBack = state.gate.querySelector('[data-flp-map-back-country]');
      if (originalBack) originalBack.hidden = false;
      if (state.map) state.map.resize();
    }, state.reducedMotion ? 0 : 360);
  }

  function clearOffscreenTimer() {
    window.clearTimeout(state.offscreenTimer);
    state.offscreenTimer = 0;
  }

  function stopViewportGuard() {
    clearOffscreenTimer();
    if (state.viewportObserver) state.viewportObserver.disconnect();
    state.viewportObserver = null;
  }

  function startViewportGuard() {
    stopViewportGuard();
    if (!state.gate || !('IntersectionObserver' in window)) return;
    state.viewportObserver = new IntersectionObserver(function (entries) {
      var entry = entries && entries[0];
      if (!entry || entry.isIntersecting) {
        clearOffscreenTimer();
        return;
      }
      if (state.offscreenTimer || !state.overlay || state.overlay.hidden || state.gate.getAttribute('data-flp-inline-mode') !== 'map') return;
      state.offscreenTimer = window.setTimeout(returnToWaitlistFromScroll, 720);
    }, {
      root: null,
      rootMargin: '65% 0px 65% 0px',
      threshold: 0
    });
    state.viewportObserver.observe(state.gate);
  }

  function disposeMap() {
    stopIdleOrbit();
    clearMarkers();
    if (state.map) {
      try { state.map.remove(); } catch (_) {}
    }
    state.map = null;
    state.mapReady = false;
    state.markerMode = '';
    state.partnerLayersBound = false;
    state.partnerByKey = {};
    state.selectedPartner = null;
    if (state.mapNode) state.mapNode.innerHTML = '';
    if (state.overlay) state.overlay.classList.remove('is-ready', 'is-map-overview', 'has-open-partner', 'is-flat');
  }

  function returnToWaitlistFromScroll() {
    clearOffscreenTimer();
    if (state.autoReturning || !state.gate || state.gate.getAttribute('data-flp-inline-mode') !== 'map') return;
    state.autoReturning = true;
    disposeMap();
    closeCityView();
    var mapBack = state.gate.querySelector('[data-flp-inline-map-back]');
    if (mapBack) mapBack.click();
    window.setTimeout(function () { state.autoReturning = false; }, 480);
  }

  function customizeMapStyle() {
    if (!state.map) return;
    var layers = state.map.getStyle() && state.map.getStyle().layers || [];
    var buildingLayer = layers.find(function (layer) { return layer.id === 'building-3d' || layer.type === 'fill-extrusion'; });
    if (buildingLayer) {
      try {
        state.map.setPaintProperty(buildingLayer.id, 'fill-extrusion-color', [
          'interpolate', ['linear'], ['coalesce', ['get', 'render_height'], ['get', 'height'], 0],
          0, '#efdbe2', 24, '#dda8ba', 80, '#bd7891'
        ]);
        state.map.setPaintProperty(buildingLayer.id, 'fill-extrusion-opacity', 0.94);
      } catch (_) {}
    }
  }

  function ensureMap(camera) {
    if (state.map) {
      state.map.resize();
      syncPartnerSource();
      syncMarkerPresentation(true);
      flyToCamera(camera);
      setLoading(false, false);
      return;
    }
    state.map = new window.maplibregl.Map({
      container: state.mapNode,
      style: createMapStyle(),
      center: camera.center,
      zoom: Math.max(11.8, camera.zoom - 2.4),
      pitch: 18,
      bearing: camera.bearing + 18,
      minZoom: 5,
      maxZoom: 20,
      maxPitch: 82,
      attributionControl: false,
      cooperativeGestures: false,
      dragRotate: true,
      pitchWithRotate: true,
      touchPitch: true,
      touchZoomRotate: true,
      canvasContextAttributes: { antialias: true }
    });
    state.map.touchPitch.enable();
    state.map.touchZoomRotate.enable();
    state.map.touchZoomRotate.enableRotation();
    state.map.dragRotate.enable();
    state.map.addControl(new window.maplibregl.NavigationControl({ showCompass: false, showZoom: true }), 'bottom-right');
    state.map.addControl(new window.maplibregl.AttributionControl({ compact: true }), 'bottom-left');
    var finishMapArrival = function () {
      if (state.mapReady) return;
      state.mapReady = true;
      customizeMapStyle();
      syncPartnerSource();
      syncMarkerPresentation(true);
      flyToCamera(camera);
      setLoading(false, false);
      state.overlay.classList.add('is-ready');
      syncPerspectiveToggle();
      showGestureHint();
      if (!state.reducedMotion) window.setTimeout(startIdleOrbit, 2600);
    };
    state.map.on('style.load', finishMapArrival);
    state.map.on('load', finishMapArrival);
    state.map.on('dragstart', stopIdleOrbit);
    state.map.on('rotatestart', stopIdleOrbit);
    state.map.on('zoomstart', stopIdleOrbit);
    state.map.on('zoom', function () { syncMarkerPresentation(false); });
    state.map.on('moveend', function () { syncMarkerPresentation(true); });
    state.map.on('pitchstart', function () {
      stopIdleOrbit();
      hideGestureHint();
    });
    state.map.on('pitch', syncPerspectiveToggle);
    state.map.on('error', function () {
      if (!state.mapReady) setLoading(true, true);
    });
  }

  function flyToCamera(camera) {
    if (!state.map) return;
    state.map.easeTo({
      center: camera.center,
      zoom: camera.zoom,
      pitch: camera.pitch,
      bearing: camera.bearing,
      duration: state.reducedMotion ? 0 : 1700,
      essential: false
    });
  }

  function syncPerspectiveToggle() {
    if (!state.map || !state.overlay) return;
    var is3d = state.map.getPitch() >= 22;
    var control = state.overlay.querySelector('[data-flp-city3d-perspective]');
    if (!control) return;
    control.setAttribute('aria-pressed', String(is3d));
    control.setAttribute('aria-label', is3d ? 'Passa alla vista 2D' : 'Passa alla vista 3D');
    Array.prototype.slice.call(control.querySelectorAll('[data-mode]')).forEach(function (label) {
      label.classList.toggle('is-active', label.getAttribute('data-mode') === (is3d ? '3d' : '2d'));
    });
    state.overlay.classList.toggle('is-flat', !is3d);
  }

  function togglePerspective() {
    if (!state.map) return;
    stopIdleOrbit();
    hideGestureHint();
    var to3d = state.map.getPitch() < 22;
    state.map.easeTo({
      pitch: to3d ? 64 : 0,
      bearing: to3d ? (Math.abs(state.map.getBearing()) < 4 ? -24 : state.map.getBearing()) : 0,
      duration: state.reducedMotion ? 0 : 720,
      essential: false
    });
  }

  function showGestureHint() {
    if (!state.overlay || state.reducedMotion || !window.matchMedia || !window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    var hint = state.overlay.querySelector('[data-flp-city3d-gesture-hint]');
    if (!hint) return;
    hint.classList.add('is-visible');
    window.clearTimeout(state.gestureHintTimer);
    state.gestureHintTimer = window.setTimeout(hideGestureHint, 4600);
  }

  function hideGestureHint() {
    window.clearTimeout(state.gestureHintTimer);
    state.gestureHintTimer = 0;
    if (!state.overlay) return;
    var hint = state.overlay.querySelector('[data-flp-city3d-gesture-hint]');
    if (hint) hint.classList.remove('is-visible');
  }

  function clearMarkers() {
    state.markers.forEach(function (marker) { marker.remove(); });
    state.markers = [];
  }

  function partnerKey(partner, index) {
    return String(partner && (partner.partnerId || partner.partnerSlug) || ('partner-' + index));
  }

  function partnerFeatureCollection() {
    var lookup = {};
    var features = [];
    state.activePartners.forEach(function (partner, index) {
      var coordinates = partnerCoordinates(partner);
      if (!coordinates) return;
      var key = partnerKey(partner, index);
      lookup[key] = partner;
      features.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: coordinates },
        properties: { partnerKey: key, partnerName: String(partner.name || 'Partner Florame') }
      });
    });
    state.partnerByKey = lookup;
    return { type: 'FeatureCollection', features: features };
  }

  function ensurePartnerLayers() {
    if (!state.map || !state.mapReady) return null;
    var source = state.map.getSource(PARTNER_SOURCE_ID);
    if (!source) {
      state.map.addSource(PARTNER_SOURCE_ID, {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] },
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 56
      });
      state.map.addLayer({
        id: 'florame-partner-clusters-halo',
        type: 'circle',
        source: PARTNER_SOURCE_ID,
        maxzoom: PARTNER_DOM_MIN_ZOOM,
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': 'rgba(255,255,255,.74)',
          'circle-radius': ['step', ['get', 'point_count'], 18, 25, 22, 100, 27, 500, 32],
          'circle-blur': 0.55
        }
      });
      state.map.addLayer({
        id: 'florame-partner-clusters',
        type: 'circle',
        source: PARTNER_SOURCE_ID,
        maxzoom: PARTNER_DOM_MIN_ZOOM,
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': ['step', ['get', 'point_count'], '#ff4e83', 25, '#f52f70', 100, '#df1758', 500, '#b90f47'],
          'circle-radius': ['step', ['get', 'point_count'], 13, 25, 17, 100, 21, 500, 25],
          'circle-stroke-width': 2.5,
          'circle-stroke-color': '#ffffff',
          'circle-opacity': 0.96
        }
      });
      state.map.addLayer({
        id: 'florame-partner-cluster-count',
        type: 'symbol',
        source: PARTNER_SOURCE_ID,
        maxzoom: PARTNER_DOM_MIN_ZOOM,
        filter: ['has', 'point_count'],
        layout: {
          'text-field': ['get', 'point_count_abbreviated'],
          'text-font': ['Noto Sans Bold'],
          'text-size': 10
        },
        paint: { 'text-color': '#ffffff' }
      });
      state.map.addLayer({
        id: 'florame-partner-points-halo',
        type: 'circle',
        source: PARTNER_SOURCE_ID,
        maxzoom: PARTNER_DOM_MIN_ZOOM,
        filter: ['!', ['has', 'point_count']],
        paint: {
          'circle-color': 'rgba(255,47,109,.2)',
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 5, 7, 14.7, 12],
          'circle-blur': 0.48
        }
      });
      state.map.addLayer({
        id: 'florame-partner-points',
        type: 'circle',
        source: PARTNER_SOURCE_ID,
        maxzoom: PARTNER_DOM_MIN_ZOOM,
        filter: ['!', ['has', 'point_count']],
        paint: {
          'circle-color': '#ff2f6d',
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 5, 3.5, 12, 5, 14.7, 6.5],
          'circle-stroke-width': 2,
          'circle-stroke-color': '#ffffff'
        }
      });
      source = state.map.getSource(PARTNER_SOURCE_ID);
    }
    if (!state.partnerLayersBound) {
      state.partnerLayersBound = true;
      state.map.on('click', 'florame-partner-clusters', function (event) {
        var feature = event.features && event.features[0];
        var clusterId = feature && feature.properties && Number(feature.properties.cluster_id);
        var clusterSource = state.map && state.map.getSource(PARTNER_SOURCE_ID);
        if (!clusterSource || !Number.isFinite(clusterId)) return;
        Promise.resolve(clusterSource.getClusterExpansionZoom(clusterId)).then(function (zoom) {
          state.map.easeTo({
            center: feature.geometry.coordinates,
            zoom: Math.min(Number(zoom) || (state.map.getZoom() + 2), 17),
            duration: state.reducedMotion ? 0 : 760
          });
        }).catch(function () {});
      });
      state.map.on('click', 'florame-partner-points', function (event) {
        var feature = event.features && event.features[0];
        var key = feature && feature.properties && String(feature.properties.partnerKey || '');
        if (key && state.partnerByKey[key]) selectPartner(state.partnerByKey[key], null);
      });
      ['florame-partner-clusters', 'florame-partner-points'].forEach(function (layerId) {
        state.map.on('mouseenter', layerId, function () { state.map.getCanvas().style.cursor = 'pointer'; });
        state.map.on('mouseleave', layerId, function () { state.map.getCanvas().style.cursor = ''; });
      });
    }
    return source;
  }

  function syncPartnerSource() {
    var source = ensurePartnerLayers();
    if (source && source.setData) source.setData(partnerFeatureCollection());
  }

  function visibleInMap(coordinates) {
    if (!state.map) return false;
    var point = state.map.project(coordinates);
    var canvas = state.map.getCanvas();
    var padding = 150;
    return point.x >= -padding && point.y >= -padding && point.x <= canvas.clientWidth + padding && point.y <= canvas.clientHeight + padding;
  }

  function syncMarkerPresentation(forceRender) {
    if (!state.map || !state.overlay) return;
    var zoom = state.map.getZoom();
    var mode = zoom < PARTNER_DOM_MIN_ZOOM ? 'dot' : (zoom < PARTNER_NAME_MIN_ZOOM ? 'logo' : 'full');
    state.overlay.classList.toggle('is-map-overview', zoom < PARTNER_DOM_MIN_ZOOM);
    var changed = mode !== state.markerMode;
    if (changed) {
      state.markerMode = mode;
      state.overlay.classList.toggle('is-marker-dot', mode === 'dot');
      state.overlay.classList.toggle('is-marker-logo', mode === 'logo');
      state.overlay.classList.toggle('is-marker-full', mode === 'full');
    }
    if (mode === 'dot') {
      if (changed || state.markers.length) clearMarkers();
      return;
    }
    if (changed || forceRender) renderMarkers();
  }

  function renderMarkers() {
    if (!state.map || !window.maplibregl) return;
    clearMarkers();
    state.activePartners.forEach(function (partner, index) {
      var coords = partnerCoordinates(partner);
      if (!coords || !visibleInMap(coords)) return;
      var key = partnerKey(partner, index);
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'flp-city3d__marker';
      button.setAttribute('data-partner-key', key);
      button.setAttribute('aria-label', 'Apri la scheda di ' + partner.name);
      button.innerHTML = '<span class="flp-city3d__marker-pulse"></span><span class="flp-city3d__marker-core">' +
        (partner.logoUrl ? '<img src="' + escapeHtml(safeUrl(partner.logoUrl, '')) + '" alt="">' : icon('shop')) +
        '</span><strong>' + escapeHtml(partner.name) + '</strong>';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        selectPartner(partner, button);
      });
      var marker = new window.maplibregl.Marker({ element: button, anchor: 'bottom', offset: [0, -4] })
        .setLngLat(coords)
        .addTo(state.map);
      state.markers.push(marker);
      if (state.selectedPartner === partner) button.classList.add('is-selected');
      if (index === 0 && state.activePartners.length === 1) button.classList.add('is-primary');
    });
  }

  function selectPartner(partner, markerElement) {
    state.selectedPartner = partner;
    hideGestureHint();
    state.overlay.classList.add('has-open-partner');
    Array.prototype.slice.call(state.overlay.querySelectorAll('.flp-city3d__marker')).forEach(function (node) {
      node.classList.toggle('is-selected', node === markerElement);
    });
    var coords = partnerCoordinates(partner);
    if (coords && state.map) {
      state.map.easeTo({
        center: coords,
        zoom: Math.max(state.map.getZoom(), 17.25),
        pitch: 68,
        bearing: -31,
        duration: state.reducedMotion ? 0 : 950,
        offset: window.innerWidth < 700 ? [0, -72] : [-118, 0]
      });
    }
    renderPartnerCard(partner);
  }

  function isOpenNow(partner) {
    var hours = partner && partner.openingHours;
    if (!hours || typeof hours !== 'object') return null;
    var keys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var slots = Array.isArray(hours[keys[new Date().getDay()]]) ? hours[keys[new Date().getDay()]] : [];
    var now = (new Date().getHours() * 60) + new Date().getMinutes();
    return slots.some(function (slot) {
      var start = String(slot.start || '').split(':').map(Number);
      var end = String(slot.end || '').split(':').map(Number);
      return start.length === 2 && end.length === 2 && now >= (start[0] * 60 + start[1]) && now <= (end[0] * 60 + end[1]);
    });
  }

  function renderPartnerCard(partner) {
    var card = state.overlay.querySelector('[data-flp-city3d-partner]');
    var open = isOpenNow(partner);
    var storefrontUrl = safeUrl(partner.storefrontUrl, 'https://florame.ai/');
    var directionsUrl = safeUrl(partner.googleMapsUrl, 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(partner.addressLine || partner.name));
    var badges = (Array.isArray(partner.badges) ? partner.badges : []).slice(0, 2);
    card.innerHTML = '' +
      '<button type="button" class="flp-city3d__card-close" data-flp-city3d-card-close aria-label="Chiudi scheda">×</button>' +
      '<div class="flp-city3d__card-head">' +
        '<span class="flp-city3d__avatar">' + (partner.logoUrl ? '<img src="' + escapeHtml(safeUrl(partner.logoUrl, '')) + '" alt="Logo ' + escapeHtml(partner.name) + '">' : icon('shop')) + '</span>' +
        '<div><span class="flp-city3d__verified"><i></i> Partner verificato</span><h4>' + escapeHtml(partner.name) + '</h4><p>' + escapeHtml(partner.addressLine || [partner.city, partner.province].filter(Boolean).join(', ')) + '</p></div>' +
      '</div>' +
      '<div class="flp-city3d__chips">' +
        (open === null ? '' : '<span class="' + (open ? 'is-open' : 'is-closed') + '">' + (open ? 'Aperto ora' : 'Chiuso ora') + '</span>') +
        (partner.pickupEnabled ? '<span>Ritiro disponibile</span>' : '') +
        badges.map(function (badge) { return '<span>' + escapeHtml(badge) + '</span>'; }).join('') +
      '</div>' +
      (partner.description ? '<p class="flp-city3d__description">' + escapeHtml(partner.description) + '</p>' : '') +
      '<div class="flp-city3d__card-actions">' +
        '<a class="flp-city3d__primary" href="' + escapeHtml(storefrontUrl) + '"><span>Entra nel suo Florame</span><b>↗</b></a>' +
        '<a class="flp-city3d__secondary" href="' + escapeHtml(directionsUrl) + '" target="_blank" rel="noopener">' + icon('pin') + '<span>Indicazioni</span></a>' +
      '</div>';
    card.hidden = false;
    card.querySelector('[data-flp-city3d-card-close]').addEventListener('click', function () {
      card.hidden = true;
      state.selectedPartner = null;
      state.overlay.classList.remove('has-open-partner');
      Array.prototype.slice.call(state.overlay.querySelectorAll('.flp-city3d__marker')).forEach(function (node) { node.classList.remove('is-selected'); });
      focusActivePartners();
    });
  }

  function focusActivePartners() {
    if (!state.map) return;
    var keepFlat = state.map.getPitch() < 22;
    var targetPitch = keepFlat ? 0 : 58;
    var targetBearing = keepFlat ? 0 : -18;
    if (state.activePartners.length > 1) {
      var bounds = new window.maplibregl.LngLatBounds();
      state.activePartners.forEach(function (partner) {
        var coords = partnerCoordinates(partner);
        if (coords) bounds.extend(coords);
      });
      if (!bounds.isEmpty()) {
        state.map.fitBounds(bounds, { padding: 90, maxZoom: 16.2, pitch: targetPitch, bearing: targetBearing, duration: state.reducedMotion ? 0 : 1100 });
        return;
      }
    }
    var camera = activeCamera();
    camera.pitch = targetPitch;
    camera.bearing = targetBearing;
    flyToCamera(camera);
  }

  function startIdleOrbit() {
    if (state.reducedMotion || !state.map || state.overlay.hidden || state.selectedPartner) return;
    stopIdleOrbit();
    var last = 0;
    function tick(time) {
      if (!state.map || state.overlay.hidden || state.selectedPartner) return;
      if (time - last > 90) {
        var bearing = state.map.getBearing() + (0.035 * state.idleDirection);
        if (bearing > -18 || bearing < -36) state.idleDirection *= -1;
        state.map.setBearing(bearing);
        last = time;
      }
      state.idleFrame = window.requestAnimationFrame(tick);
    }
    state.idleFrame = window.requestAnimationFrame(tick);
  }

  function stopIdleOrbit() {
    if (state.idleFrame) window.cancelAnimationFrame(state.idleFrame);
    state.idleFrame = 0;
  }

  function decorateCoverageMap() {
    if (!state.gate) return;
    var countries = {};
    var regions = {};
    state.partners.forEach(function (partner) {
      countries[String(partner.countryCode || 'IT').toUpperCase()] = true;
      if (partner.regionCode) regions[String(partner.regionCode).toUpperCase()] = true;
      if (partner.regionName) regions[normalize(partner.regionName)] = true;
    });
    Array.prototype.slice.call(state.gate.querySelectorAll('[data-flp-map-kind="country"]')).forEach(function (path) {
      path.classList.toggle('flp-inline-map-region--partner', !!countries[String(path.getAttribute('data-flp-map-id') || '').toUpperCase()]);
    });
    Array.prototype.slice.call(state.gate.querySelectorAll('[data-flp-map-kind="region"]')).forEach(function (path) {
      var id = String(path.getAttribute('data-flp-map-id') || '').toUpperCase();
      var label = normalize(path.getAttribute('data-flp-map-label'));
      path.classList.toggle('flp-inline-map-region-split--partner', !!regions[id] || !!regions[label]);
    });
    var observerTarget = state.gate.querySelector('[data-flp-inline-map-layer]');
    if (observerTarget && !observerTarget.getAttribute('data-flp-city3d-observed')) {
      observerTarget.setAttribute('data-flp-city3d-observed', 'true');
      new MutationObserver(decorateCoverageMap).observe(observerTarget, { childList: true });
    }
  }

  function bindRegionEvents() {
    document.addEventListener('flp:coverage-region-selected', function (event) {
      var detail = event && event.detail || null;
      window.setTimeout(function () { openCityView(detail); }, state.reducedMotion ? 0 : 420);
    });
    var home = state.gate.querySelector('[data-flp-map-home]');
    if (home) home.addEventListener('click', function () {
      if (state.overlay && !state.overlay.hidden) closeCityView();
    }, true);
    new MutationObserver(function () {
      if (state.gate.getAttribute('data-flp-inline-mode') !== 'map' && state.overlay && !state.overlay.hidden) closeCityView();
    }).observe(state.gate, { attributes: true, attributeFilter: ['data-flp-inline-mode'] });
  }

  function init() {
    state.gate = document.querySelector('[data-flp-inline-gate]');
    state.stage = document.querySelector('[data-flp-map-stage]');
    if (!state.gate || !state.stage || state.stage.getAttribute('data-flp-city3d-ready') === 'true') return;
    state.stage.setAttribute('data-flp-city3d-ready', 'true');
    buildOverlay();
    bindRegionEvents();
    loadPartners();
    window.FlorameCoverageCity3D = {
      open: openCityView,
      close: closeCityView,
      partners: function () { return state.partners.slice(); },
      debug: function () {
        return {
          ready: !!state.mapReady,
          pitch: state.map ? state.map.getPitch() : null,
          bearing: state.map ? state.map.getBearing() : null,
          touchPitch: !!(state.map && state.map.touchPitch && state.map.touchPitch.isEnabled()),
          touchZoomRotate: !!(state.map && state.map.touchZoomRotate && state.map.touchZoomRotate.isEnabled()),
          dragRotate: !!(state.map && state.map.dragRotate && state.map.dragRotate.isEnabled()),
          partnerCardOpen: !!state.selectedPartner,
          partnerCount: state.activePartners.length,
          zoom: state.map ? state.map.getZoom() : null,
          markerMode: state.markerMode,
          mapOverview: !!(state.overlay && state.overlay.classList.contains('is-map-overview')),
          renderedHtmlMarkers: state.markers.length,
          clusteredSourceReady: !!(state.map && state.map.getSource && state.map.getSource(PARTNER_SOURCE_ID)),
          viewportGuardActive: !!state.viewportObserver,
          detailLayers: state.map && state.map.getStyle ? state.map.getStyle().layers.filter(function (layer) {
            return /^florame-(road-labels|district-labels|neighbourhood-labels|settlement-labels|poi-labels|house-numbers|buildings-3d)$/.test(layer.id);
          }).map(function (layer) { return layer.id; }) : []
        };
      }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
